import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-novya-dark text-white mt-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display font-black text-5xl tracking-tighter leading-none">
            Novya<span className="text-novya-accent">.</span>
          </div>
          <p className="mt-6 max-w-md text-white/70 leading-relaxed">
            A cohort-based tech academy for people making the leap into serious careers. Practitioner-led, portfolio-graded, hire-focused.
          </p>
          <p className="mt-8 font-mono text-[10px] tracking-[0.25em] uppercase text-white/40" data-testid="footer-powered-by">
            Novya · powered by Vunathi Tech
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Programs</div>
          <ul className="space-y-3 text-white/80 text-sm">
            <li><Link to="/programs/software-engineering" className="hover:text-white">Software Engineering</Link></li>
            <li><Link to="/programs/ai-ml" className="hover:text-white">AI & Machine Learning</Link></li>
            <li><Link to="/programs/data-science" className="hover:text-white">Data Science</Link></li>
            <li><Link to="/programs/product-design" className="hover:text-white">Product Design</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Company</div>
          <ul className="space-y-3 text-white/80 text-sm">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/programs" className="hover:text-white">Curriculum</Link></li>
            <li><Link to="/advisor/book" className="hover:text-white">Talk to advisor</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3" data-testid="footer-contact">
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Contact</div>
          <div className="text-white/80 text-sm leading-relaxed space-y-1">
            <div><a href="mailto:info@vunathi.com" className="hover:text-white">info@vunathi.com</a></div>
            <div>A-Square Business Centre</div>
            <div>Visakhapatnam · 530003</div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center text-white/40 font-mono text-[10px] tracking-[0.2em] uppercase gap-2">
          <div>© {new Date().getFullYear()} Novya · Vunathi Tech</div>
          <div>Built for career leaps</div>
        </div>
      </div>
    </footer>
  );
}
